import { PAYMENT_V2_ENDPOINT_V2 } from "@/components/Pricing/v2/constants.pricing";
import { TCloudAPIResponse } from "@/types/app";
import { TPricingVersion, TUserPlanData } from "@/types/plan-data";
import axios, { AxiosResponse } from "axios";

const APIURL = `${PAYMENT_V2_ENDPOINT_V2}/user/plan`;

type TResponse = TCloudAPIResponse<TUserPlanData>;

const fetchUserPlan = async (
  token?: string,
  version: TPricingVersion = "v1",
) => {
  const response: AxiosResponse<TResponse> = await axios.get(APIURL, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = response.data;

  return data.data;
};

export default fetchUserPlan;
